var checkoutContainer = null;
var checkoutInitInterval;

export const initCheckout = () => {
    if (document.body.classList.contains("woocommerce-checkout")) {
        checkoutInitInterval = setInterval(function () {
            checkInitCheckoutModifiers();
        }, 200);
        checkInitCheckoutModifiers();
    }
};

const checkInitCheckoutModifiers = () => {
    checkoutContainer = document.querySelector(
        ".wp-block-woocommerce-checkout",
    );
    if (checkoutContainer !== null) {
        clearInterval(checkoutInitInterval);
        initCheckoutModifiers();
    }
};

const initCheckoutModifiers = () => {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === "childList") {
                if (
                    mutation.target.classList.contains(
                        "wp-block-woocommerce-checkout-order-summary-block",
                    )
                ) {
                    setTimeout(changeCheckoutWording(), 500);
                }
            }
        }
    });

    // Start observing the cart container for changes
    if (checkoutContainer) {
        observer.observe(checkoutContainer, { childList: true, subtree: true });
    }
};

function changeCheckoutWording() {
    const createAccount = document.querySelector(
        ".wc-block-checkout__create-account span",
    );

    if (document.querySelector(".wc-block-components-totals-coupon button")) {
        document.querySelector(
            ".wc-block-components-totals-coupon button",
        ).childNodes[1].nodeValue = bm_variables.add_coupon_text;
    }

    if (createAccount) {
        createAccount.innerHTML = bm_variables.checkout_create_account;
    }

    document.querySelector(
        ".wc-block-components-order-summary__button-text",
    ).innerHTML = bm_variables.checkout_summery_title;
}
